import(/* webpackMode: "eager" */ "/codebuild/output/src2204151308/src/tireco-pinecone-app/client/src/app/layout.tsx");
